import styled from 'styled-components';
import Video from '../Video';

export const StyledResponsiveVideo = styled(Video)`
  width: 100%;
  height: 100%;
  padding-bottom: 0;
`;
